import React, { useState } from 'react';

export default function ProductVisualSearch() {
  const [selectedFile, setSelectedFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState(null);
  const [error, setError] = useState(null);

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setSelectedFile(e.target.files[0]);
      setError(null);
    }
  };

  const handleSearchSubmit = async () => {
    if (!selectedFile) {
      setError('Please select a file first.');
      return;
    }

    setLoading(true);
    setError(null);

    const formData = new FormData();
    formData.append('photo', selectedFile);

    try {
      const response = await fetch('/api/vision-products/query-product', {
        method: 'POST',
        body: formData,
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Failed to search product catalog.');
      }

      setResults(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 bg-white rounded-lg shadow border border-gray-200">
      <div className="flex flex-col space-y-4">
        {/* Unstyled standard file input */}
        <input
          type="file"
          onChange={handleFileChange}
          accept="image/*"
        />

        {/* Styled upload button below it */}
        <button
          onClick={handleSearchSubmit}
          disabled={loading || !selectedFile}
          className="w-full py-2 px-4 bg-indigo-600 text-white font-medium rounded shadow hover:bg-indigo-700 disabled:bg-indigo-400 disabled:cursor-not-allowed transition-colors text-sm"
        >
          {loading ? 'Searching...' : 'Upload & Search'}
        </button>
      </div>

      {error && <p className="mt-3 text-sm text-red-600">⚠️ {error}</p>}

      {/* Results summary */}
      {results && (
        <div className="mt-6 pt-4 border-t border-gray-200">
          <p className="text-sm font-semibold text-gray-900">Found {results.count} matches</p>
          <div className='flex flex-wrap'>
            {results.products.map((p) => (
              <div className='w-full lg:w-1/3  p-2'>
                <div className='border border-black p-1'>
                  <div className='flex justify-between text-xs'>
                    <div>MediaId : {p.mediaId}</div>
                    <div>Score: {(p.score * 100).toFixed(1)}%</div>
                  </div>
                </div>


                <div className='flex justify-center'>
                  <img className='max-h-80 ' src={p.imageUrl} />
                </div>


              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
